<template>

    <form action="/site/contact" @submit="checkForm" method="post">
        <input type="text" id="name" name="name" :placeholder="t('ct_f_name')" :title="t('ct_f_name')" v-model="name"
               @input="resetError('name')">
        <div v-if="errors.name.length > 0">
            <ul class="error">
                <li :key="index" v-for="(error,index) in errors.name">{{error}}</li>
            </ul>
        </div>
        <input type="text" id="email" name="email" :placeholder="t('ct_f_email')" :title="t('ct_f_email')"
               v-model="email" @input="resetError('email')">
        <div v-if="errors.email.length > 0">
            <ul class="error">
                <li :key="index" v-for="(error,index) in errors.email">{{error}}</li>
            </ul>
        </div>
        <select name="subject" id="subject" v-model="subject" 
                :placeholder="t('ct_f_subject')" :title="t('ct_f_subject')">
            <option :value="0" v-translate="'ct_f_subject_0'"></option>
            <option :value="1" v-translate="'ct_f_subject_1'"></option>
            <option :value="2" v-translate="'ct_f_subject_2'"></option>
            <option :value="3" v-translate="'ct_f_subject_3'"></option>
            <option :value="4" v-translate="'ct_f_subject_4'"></option>
            <option :value="5" v-translate="'ct_f_subject_5'"></option>
        </select>
        <div v-if="errors.subject.length > 0">
            <ul class="error">
                <li :key="index" v-for="(error,index) in errors.subject">{{error}}</li>
            </ul>
        </div>

        <textarea :placeholder="t('ct_f_message')" :title="t('ct_f_message')" name="message" v-model="message"
                  @input="resetError('message')"></textarea>
        <div v-if="errors.message.length > 0">
            <ul class="error">
                <li :key="index" v-for="(error,index) in errors.message">{{error}}</li>
            </ul>
        </div>
        <input type="hidden" id="form-token" name="_csrf-frontend" v-bind:value="token">


      <div class="regs">
            <label class="form-item">
                <input id="reg_1" value="reg_1" v-model="reg_1" type="checkbox">
                <span class="checkmark"></span>
                <strong v-translate="'CONTACT_reg1'">Wyrażam zgodę na przetwarzanie moich danych osobowych przez administratora KROSS S.A. z siedzibą w Przasnyszu 
                    w celu obsługi mojego zgłoszenia i udzielenia odpowiedzi na zadane pytania. Dane te nie będą wykorzystywane do żadnych innych celów bez Twojej 
                    uprzedniej zgody. Aby dowiedzieć się więcej na temat zasad na jakich przetwarzamy Twoje dane oraz o przysługujących Ci w związku z tym prawach, 
                    zapoznaj się z Polityką Prywatności</strong>
            </label>

            <div v-if="errors.reg_1.length > 0">
                <ul class="error">
                    <li :key="index" v-for="(error,index) in errors.reg_1">{{error}}</li>
                </ul>
            </div>

            <label class="form-item">
                <input id="reg_2" value="reg_2" v-model="reg_2" type="checkbox">
                <span class="checkmark"></span>
                <span v-translate="'CONTACT_reg2'">Wyrażam zgodę na przetwarzanie moich danych osobowych przez administratora KROSS S.A. z siedzibą w Przasnyszu, 
                    w celach marketingowych, w tym do przesyłania newsletterów o promocjach i ofertach specjalnych. Więcej informacji odnośnie przetwarzania danych 
                    osobowych przez KROSS S.A. można znaleźć w Polityką prywatności.</span>
            </label>
            <label class="form-item">
                <input id="reg_3" value="reg_3" v-model="reg_3" type="checkbox">
                <span class="checkmark"></span>

              <span v-translate="'CONTACT_reg3'">Wyrażam zgodę na otrzymywanie od KROSS S.A. informacji handlowych drogą elektroniczną.</span>
            </label>
            <label class="form-item">
                <input id="reg_4" value="reg_4" v-model="reg_4" type="checkbox">
                <span class="checkmark"></span>

              <span v-translate="'CONTACT_reg4'">Wyrażam zgodę na używanie telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących
                   do celów marketingu bezpośredniego.</span>
            </label>
        </div>
        <button type="submit" v-translate="'submit'">Wyślij</button>

    </form>

</template>
<script>
    export default {
        name: 'ContactForm',
        props: {
            token: String
        },
        data() {
            return {
                errors: {
                    name: [],
                    email: [],
                    subject: [],
                    reg_1: [],
                    message: [],
                },
                name: null,
                email: null,
                subject: null,
                message: null,
                reg_1: false,
                reg_2: false,
                reg_3: false,
                reg_4: false
            }
        },
        methods: {
            t(text) {
                if (window.translations[text])
                    return window.translations[text];
                else return text;
            },
            resetError(field) {
                this.errors[field] = [];
            },
            resetErrors() {
                this.errors.name = [];
                this.errors.email = [];
                this.errors.subject = [];
                this.errors.reg_1 = [];
                this.errors.message = [];
            },
            checkForm: function (e) {
                let mailIsValid = this.isEmail(this.email);
                if (this.name && mailIsValid && this.subject && this.message && this.reg_1) return true;
                this.resetErrors();
                if (!this.name) this.errors.name.push(this.t('ct_e_required'));
                if (!this.email) this.errors.email.push(this.t('ct_e_required'));
                if (!mailIsValid) this.errors.email.push(this.t('ct_e_email'));
                if (!this.subject) this.errors.subject.push(this.t('ct_e_required'));
                if (!this.message) this.errors.message.push(this.t('ct_e_required'));
                if (!this.reg_1) this.errors.reg_1.push(this.t('ct_e_required'));
                e.preventDefault();
            },
            isEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Blocks/ContactForm.vue